import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { User } from 'oidc-react';
import { jwtDecode } from 'jwt-decode';
import { IdTokenClaims, JwtClaims } from 'oidc-client-ts';
import { exchangeCodeManually, getUserInfo } from '../Services/Auth/ManualTokenExchangeService';
import { ClaimService } from '../Services/Auth/ClaimService';
import { PWUserManager } from '../config/oidcconfig';

export const Impersonation = () => {
  const [location] = useLocation();

  useEffect(() => {
    const handleImpersonation = async () => {
      if (location === '/impersonation') {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const codeVerifier = urlParams.get('code_verifier') ?? undefined;
        const redirectUri = window.location.origin + '/impersonation';

        if (code) {
          const tokens = await exchangeCodeManually(code, redirectUri, codeVerifier);
          const decodedToken = jwtDecode<JwtClaims>(tokens.access_token);
          const userInfo = await getUserInfo(tokens.access_token);
          const userProfile = new ClaimService().mergeClaims(decodedToken, userInfo);
          const user = new User({
            access_token: tokens.access_token,
            token_type: tokens.token_type,
            profile: userProfile as IdTokenClaims,
          });
          PWUserManager.storeUser(user);
          window.location.href = '/';
        }
      }
    };
    handleImpersonation();
  }, [location]);

  return null;
};
